import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useTranslations } from "next-intl";
import { CreateTenantForm } from "@/components/platform-admin/create-tenant-form";
import { EmailUsageCard } from "@/components/platform-admin/email-usage-card";
import { PlatformGate } from "@/components/platform-admin/platform-gate";
import { SCHOOL_LIST_QUERY_KEY, SchoolList } from "@/components/platform-admin/school-list";

/**
 * The platform console (MT-1 AUTH-009 S12). Only a platform session opens it (`PlatformGate`).
 * After a create, the console opens the new school's page (MT-1 Plan 2 S14).
 */
export function PlatformAdminPage() {
  const t = useTranslations("platform");
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return (
    <PlatformGate>
      {(email) => (
        <main className="mx-auto max-w-4xl px-4 py-10" data-testid="platform-admin">
          <h1 className="text-2xl font-semibold">{t("title")}</h1>
          <p className="mt-2 text-[var(--text-muted)]">{t("subtitle")}</p>
          <p className="mt-4 text-sm text-[var(--text-muted)]">{t("signedInAs", { email })}</p>
          <EmailUsageCard />
          <SchoolList />
          <CreateTenantForm
            onCreated={(created) => {
              void queryClient.invalidateQueries({ queryKey: SCHOOL_LIST_QUERY_KEY });
              if (created?.tenantId) navigate(`/platform/admin/schools/${created.tenantId}`);
            }}
          />
        </main>
      )}
    </PlatformGate>
  );
}
